export default __webpack_public_path__ + "static/media/card2.25868b44.png";